import React from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { MiniLogoSQ, LeftVector, RightVector } from "../../assets";
import AuthInput from "../../components/ui/AuthInput/AuthInput";
import { ToastContainer } from "react-toastify";
import { useSignup } from "../../hooks/useSignup";
import {
  faChevronLeft,
  faUser,
  faEnvelope,
  faLock,
  faUserPlus,
  faPhone,
} from "@fortawesome/free-solid-svg-icons";
import "./SignupPage.css";

const SignupPage = () => {
  const {
    formData,
    errors,
    touched,
    loading,
    acceptedConditions,
    setAcceptedConditions,
    handleChange,
    handleSubmit,
  } = useSignup();

  const inputClass = (field) =>
    `input w-100 ${errors[field] && touched[field] ? "input-error" : ""}`;
  return (
    <div className="signup-page">
      <div className="back-link">
        <Link to="/" style={{ color: "#EF4346", textDecoration: "none" }}>
          <FontAwesomeIcon icon={faChevronLeft} /> Retour
        </Link>
      </div>
      <img src={LeftVector} alt="left" className="vibrate-1 leftImageStyle" />
      <img
        src={RightVector}
        alt="Right"
        className="vibrate-2 rightImageStyle"
      />

      <div className="signup-content">
        <img src={MiniLogoSQ} alt="SmartQuest Logo" className="logo_reg" />
        <h2 className="title">Inscription</h2>

        <p className="subtitle">
          <span style={{ color: "#444" }}>Bienvenue sur </span>
          <span style={{ color: "#4D6466" }}>Smart</span>
          <span style={{ color: "#EF4346" }}>Quest</span>
        </p>

        <form className="signup-form" onSubmit={handleSubmit}>
          {/* Nom + Prénom */}
          <div className="row mt-0">
            <div className="col-md-6">
              <AuthInput
                label="Nom"
                name="last_name"
                placeholder="Votre Nom"
                icon={faUser}
                value={formData.last_name}
                onChange={handleChange}
                error={errors.last_name}
                inputClass={inputClass}
              />
            </div>
            <div className="col-md-6">
              <AuthInput
                label="Prénom"
                name="first_name"
                placeholder="Prénom"
                icon={faUser}
                value={formData.first_name}
                onChange={handleChange}
                error={errors.first_name}
                inputClass={inputClass}
              />
            </div>
          </div>

          {/* Profession + Adresse */}
          <div className="row mt-0">
            <div className="col-md-6">
              <AuthInput
                label="Profession"
                name="profession"
                placeholder="Votre Profession"
                icon={faUser}
                value={formData.profession}
                onChange={handleChange}
                error={errors.profession}
                inputClass={inputClass}
              />
            </div>
            <div className="col-md-6">
              <AuthInput
                label="Adresse professionnelle"
                name="professional_address"
                placeholder="Adresse professionnelle"
                icon={faUser}
                value={formData.professional_address}
                onChange={handleChange}
                error={errors.professional_address}
                inputClass={inputClass}
              />
            </div>
          </div>

          {/* Sexe */}
          <div className="mt-2">
            <label className="text ms-3">Sexe</label>
            <div className="sexe-container">
              {["homme", "femme"].map((gender) => (
                <React.Fragment key={gender}>
                  <input
                    type="radio"
                    className="btn-check"
                    name="gender"
                    id={gender}
                    value={gender}
                    checked={formData.gender === gender}
                    onChange={handleChange}
                  />
                  <label className="sexe-btn" htmlFor={gender}>
                    {gender.charAt(0).toUpperCase() + gender.slice(1)}
                  </label>
                </React.Fragment>
              ))}
            </div>
            {errors.gender && <span className="error">{errors.gender}</span>}
          </div>

          {/* Email + Date de naissance */}
          <div className="row mt-2">
            <div className="col-md-6">
              <AuthInput
                label="Email"
                name="email"
                placeholder="Votre Email"
                icon={faEnvelope}
                value={formData.email}
                onChange={handleChange}
                error={errors.email}
                inputClass={inputClass}
              />
            </div>
            <div className="col-md-6">
              <AuthInput
                label="Date de naissance"
                name="date_of_birth"
                type="date"
                value={formData.date_of_birth}
                onChange={handleChange}
                error={errors.date_of_birth}
                inputClass={inputClass}
              />
            </div>
          </div>

          {/* Mot de passe */}
          <div className="row mt-2">
            <div className="col-md-6">
              <AuthInput
                label="Mot de passe"
                name="password"
                type="password"
                placeholder="********"
                icon={faLock}
                value={formData.password}
                onChange={handleChange}
                error={errors.password}
                inputClass={inputClass}
              />
            </div>
            <div className="col-md-6">
              <AuthInput
                label="Confirmer mot de passe"
                name="confirm_password"
                type="password"
                placeholder="********"
                icon={faLock}
                value={formData.confirm_password}
                onChange={handleChange}
                error={errors.confirm_password}
                inputClass={inputClass}
              />
            </div>
          </div>

          {/* Téléphone */}
          <div className="row mt-0">
            <div className="col-md-6">
              <AuthInput
                label="Numéro de téléphone"
                name="phone"
                placeholder="Votre numéro de téléphone"
                icon={faPhone}
                value={formData.phone}
                onChange={handleChange}
                error={errors.phone}
                inputClass={inputClass}
              />
            </div>

            {/* Conditions */}
            <div className="col-md-6">
              <div className="form-check ps-0 mt-3 d-flex align-items-center justify-content-start">
                <label className="form-check-label me-3" htmlFor="conditions">
                  J'ai lu les{" "}
                  <a href="/" className="text-danger text-decoration-none">
                    conditions d'utilisation
                  </a>{" "}
                  et je les accepte.
                </label>
                <div className="checkbox">
                  <input
                    className="tgl"
                    id="toggle"
                    type="checkbox"
                    checked={acceptedConditions}
                    onChange={(e) => setAcceptedConditions(e.target.checked)}
                  />
                  <label className="tgl-btn" htmlFor="toggle"></label>
                </div>
              </div>
            </div>
          </div>

          {/* Submit button */}
          <div className="d-flex justify-content-center align-items_center mt-4">
            <button type="submit" className="signup-btn" disabled={loading}>
              <FontAwesomeIcon icon={faUserPlus} className="me-2" />
              {loading ? "Inscription..." : "Inscription"}
            </button>
          </div>

          <ToastContainer position="top-center" autoClose={2000} />
        </form>
      </div>
    </div>
  );
};
export default SignupPage;
